var map = {
	"./HTML5.svg": 801,
	"./actix.svg": 802,
	"./aiohttp.svg": 803,
	"./amd.svg": 804,
	"./amixr.svg": 805,
	"./android.svg": 806,
	"./angularjs.svg": 807,
	"./app-engine.svg": 808,
	"./apple.svg": 809,
	"./asana.svg": 810,
	"./asayer.svg": 811,
	"./auth0.svg": 812,
	"./aws.svg": 813,
	"./awslamda.svg": 814,
	"./azure.svg": 815,
	"./backbone.svg": 816,
	"./bitbucket.svg": 817,
	"./bootstrap.svg": 818,
	"./bottle.svg": 819,
	"./campfire.svg": 820,
	"./celery.svg": 821,
	"./chrome.svg": 822,
	"./clickup.svg": 823,
	"./clubhouse.svg": 824,
	"./cordova.svg": 825,
	"./csharp.svg": 826,
	"./dart.svg": 827,
	"./datadog.svg": 828,
	"./default.svg": 829,
	"./django.svg": 830,
	"./dotnet.svg": 831,
	"./electron.svg": 832,
	"./elixir.svg": 833,
	"./ember.svg": 834,
	"./express.svg": 835,
	"./falcon.svg": 836,
	"./firetv.svg": 837,
	"./flask.svg": 838,
	"./flowdock.svg": 839,
	"./flutter.svg": 840,
	"./fsharp.svg": 841,
	"./fullstory.svg": 842,
	"./gcp.svg": 843,
	"./generic.svg": 844,
	"./github.svg": 845,
	"./gitlab.svg": 846,
	"./go.svg": 847,
	"./google.svg": 848,
	"./heroku.svg": 849,
	"./intellinote.svg": 850,
	"./ios.svg": 851,
	"./java.svg": 852,
	"./javascript.svg": 853,
	"./jira.svg": 854,
	"./koa.svg": 855,
	"./kotlin.svg": 856,
	"./laravel.svg": 857,
	"./lighthouse.svg": 858,
	"./linear.svg": 859,
	"./logback.svg": 860,
	"./mnet.svg": 861,
	"./msteams.svg": 862,
	"./nativec.svg": 863,
	"./nodejs.svg": 864,
	"./okta.svg": 865,
	"./onelogin.svg": 866,
	"./opsgenie.svg": 867,
	"./pagerduty.svg": 868,
	"./perl.svg": 869,
	"./phabricator.svg": 870,
	"./php.svg": 871,
	"./pivotaltracker.svg": 872,
	"./pushover.svg": 873,
	"./pyramid.svg": 874,
	"./python.svg": 875,
	"./rails.svg": 876,
	"./react.svg": 877,
	"./redis.svg": 878,
	"./redmine.svg": 879,
	"./redux.svg": 880,
	"./relay.svg": 881,
	"./rippling.svg": 882,
	"./rocketchat.svg": 883,
	"./rookout.svg": 884,
	"./ruby.svg": 885,
	"./rust.svg": 886,
	"./saml2.svg": 887,
	"./segment.svg": 888,
	"./sentry.svg": 889,
	"./slack.svg": 890,
	"./split.svg": 891,
	"./sprintly.svg": 892,
	"./swift.svg": 893,
	"./symfony.svg": 894,
	"./taiga.svg": 895,
	"./teamwork.svg": 896,
	"./tornado.svg": 897,
	"./trello.svg": 898,
	"./tryton.svg": 899,
	"./twilio.svg": 900,
	"./unity.svg": 901,
	"./vercel.svg": 902,
	"./visualbasic.svg": 903,
	"./vue.svg": 904,
	"./windows.svg": 905,
	"./youtrack.svg": 906,
	"./zendesk.svg": 907,
	"./zulip.svg": 908
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 996;